<template>

    <m-edit1/>

    <router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' />

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";



export default {
    name: 'HomeView',
    components: {mEdit1,  },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
